'use es6';

import Actions from 'AdsUI/lib/Actions';
import { Map as ImmutableMap } from 'immutable';
import CouponStateRecord from 'AdsUI/records/CouponStateRecord';
export default ((state = new ImmutableMap(), action) => {
  const {
    type,
    payload = {}
  } = action;

  switch (type) {
    case Actions.COUPONS_FETCH_SUCCEEDED:
      state = Object.keys(payload).reduce((memo, network) => memo.set(network, new CouponStateRecord(payload[network])), new ImmutableMap());
      break;

    case Actions.COUPON_DISMISS_START:
      state = state.delete(payload.network);
      break;

    default:
      break;
  }

  return state;
});